var handlebars = require('handlebars/dist/cjs/handlebars')["default"];

handlebars.Visitor = require('handlebars/dist/cjs/handlebars/compiler/visitor')["default"];

var printer = require('handlebars/dist/cjs/handlebars/compiler/printer');
handlebars.PrintVisitor = printer.PrintVisitor;
handlebars.print = printer.print;

module.exports = handlebars;


// WEBPACK FOOTER //
// ./webroot/js/handlebars-require.js